export default {
  specialHours: {},
}
